import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { MediaVideoModel } from '@modules/media/models/media-video.model';
import { PlayerModel } from '@modules/media/models/player.model';

import { ScrubberComponent } from '../../../../ui/scrubber/scrubber.component';
import { DurationComponent } from '../../../duration/duration.component';
import { VideoPreviewComponent } from '../video-preview/video-preview.component';

@Component({
  selector: 'mb-video-scrubber',
  templateUrl: './video-scrubber.component.html',
  styleUrls: ['./video-scrubber.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScrubberComponent, VideoPreviewComponent, DurationComponent, AsyncPipe],
})
export class VideoScrubberComponent {
  public seekVal = 0;

  @Input() player!: PlayerModel;
  @Input() media!: MediaVideoModel;

  public hoverSeek(value: any) {
    this.seekVal = value;
  }
}
